import React from 'react';

const NotFound = () => {
  return (
    <div className="NotFound">
      Este es el NotFound
    </div>
  );
};

export default NotFound;
